<template>
  <div class="exam_page">
    <span class="exam_page_span"></span>
    <div class="exam_main" ref="middle_page">
      <div class="examPage">
        <div class="exam_begins_box">
          <p class="examination_notes">{{$t('courseProgress.learningProcess')}}</p>
          <div class="exam_begins_rule">
            <el-form :inline="true" :model="form" class="form-item">
              <el-form-item label class="font_col">
                <el-col class="line text-center" :span="7">{{$t('courseList.courseName')}}</el-col>
                <el-col :span="15">
                  <el-input
                    :placeholder="$t('courseList.courseNameInput')"
                    maxlength="20"
                    v-model="keyword"
                    style="width: 100%;height: 10%;"
                    clearable
                  ></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label class="font_col" style>
                <el-col class="line text-center" :span="6">{{$t('courseList.validityPeriod')}}</el-col>
                <el-col :span="8">
                  <el-date-picker
                    format="yyyy/MM/dd"
                    value-format="yyyy-MM-dd"
                    v-model="startOfValidity"
                    @change="startCalendarClick"
                    type="date"
                    :placeholder="$t('courseList.chooseDate')"
                    style="width: 100%;height: 10%;"
                    :picker-options="startDate"
                  ></el-date-picker>
                </el-col>
                <el-col class="line text-center" :span="2">{{$t('courseList.to')}}</el-col>
                <el-col :span="8">
                  <el-date-picker
                    format="yyyy/MM/dd"
                    value-format="yyyy-MM-dd"
                    v-model="endOfValidity"
                    @change="endCalendarClick"
                    type="date"
                    :placeholder="$t('courseList.chooseDate')"
                    style="width: 100%;height: 10%;"
                    :picker-options="endDate"
                  ></el-date-picker>
                </el-col>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="exam_btn"
                  @click="search"
                  style="float: left"
                >{{$t('courseProgress.search')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="course_box">
            <div class="exam_begins_rule_content">
              <el-table :data="tableInfo" style="width: auto" :header-cell-style="rowClass">
                <el-table-column
                  fixed
                  type="index"
                  :label="$t('courseList.no')"
                  header-align="left"
                  align="right"
                >
                  <template slot-scope="scope">{{(page - 1) * limit + scope.$index + 1}}</template>
                </el-table-column>
                <el-table-column
                  fixed
                  prop="courseName"
                  :label="$t('courseList.courseName')"
                  align="left"
                  min-width="250px"
                  width="250px"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  fixed
                  prop="startEnd"
                  :label="$t('courseList.validityPeriod')"
                  align="left"
                  min-width="190px"
                ></el-table-column>
                <el-table-column
                  fixed
                  prop="dateStart2"
                  :label="$t('courseProgress.learnBeginDate')"
                  align="left"
                  min-width="110px"
                ></el-table-column>
                <el-table-column
                  fixed
                  :label="$t('courseProgress.learningProcess')"
                  align="left"
                  min-width="160px"
                >
                  <template slot-scope="scope" align="right">
                    <el-progress
                      v-if="(scope.row.stateNum/(scope.row.stateNum+scope.row.unstateNum))*100 > 70"
                      :percentage="float(scope.row.stateNum,scope.row.unstateNum)"
                      :stroke-width="20"
                      :text-inside="true"
                      :show-text="true"
                      status="success"
                    ></el-progress>
                    <el-progress
                      v-if="(scope.row.stateNum/(scope.row.stateNum+scope.row.unstateNum))*100 < 40"
                      :percentage="float(scope.row.stateNum,scope.row.unstateNum)"
                      :stroke-width="20"
                      :text-inside="true"
                      :show-text="true"
                      status="exception"
                    ></el-progress>
                    <el-progress
                      v-if="70 > (scope.row.stateNum/(scope.row.stateNum+scope.row.unstateNum))*100 && (scope.row.stateNum/(scope.row.stateNum+scope.row.unstateNum))*100 > 40"
                      :percentage="float(scope.row.stateNum,scope.row.unstateNum)"
                      :stroke-width="20"
                      :text-inside="true"
                      :show-text="true"
                      status="warning"
                    ></el-progress>
                  </template>
                </el-table-column>
                <el-table-column
                  fixed
                  prop="stateNum"
                  :label="$t('courseProgress.complete')"
                  header-align="left"
                  align="center"
                  min-width="100px"
                ></el-table-column>
                <el-table-column
                  fixed
                  prop="unstateNum"
                  :label="$t('courseProgress.uncomplete')"
                  header-align="left"
                  align="center"
                  min-width="100px"
                ></el-table-column>
              </el-table>
              <div style="text-align:center">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  layout="prev, pager, next"
                  :total="totalPage"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import en from "element-ui/lib/locale/lang/en";
import ja from "element-ui/lib/locale/lang/ja";
import vi from "element-ui/lib/locale/lang/vi";
import zh from "element-ui/lib/locale/lang/zh-CN";
import picker from "../../../node_modules/element-ui/lib/locale/index";

export default {
  name: "exam_begins",
  data() {
    return {
      startDate: {
        disabledDate: (time) => {
          if (this.form.createEndTime) {
            return time.getTime() > new Date(this.form.createEndTime).getTime();
          }
        },
      },
      endDate: {
        disabledDate: (time) => {
          if (this.form.createBeginTime) {
            return (
              time.getTime() <
              new Date(this.form.createEndTime).getTime() - 20 * 3600 * 1000
            );
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      // 表单中的变量
      form: {
        courseName: "",
        createBeginTime: "",
        createEndTime: "",
        templateType: "",
        templateStatus: "",
        title: "",
        source: "",
        startDate: "",
        endDate: "",
        userName: "",
      },
      status: "",
      resultFlag: false, //结果标志
      pageNum: 1, //当前页码
      pageSize: 5, //每页数量
      totalPage: 14, //总页数
      searchResultList: [], //搜索结果
      datatablelist: [],
      total: 14,
      page: 1,
      limit: 5,
      item: null,
      userId: null, //用户id
      courseId: null,
      courseName: null, //课程id
      tableInfo: [],
      percentage: null,
      calendarClickList: [],
      calendarClickList1: [],
      keyword: null,
      startOfValidity: null,
      endOfValidity: null,
    };
  },
  mounted() {
    if (this.$lang() == "1") {
      picker.use(zh);
    } else if (this.$lang() == "2") {
      picker.use(en);
    } else if (this.$lang() == "3") {
      picker.use(ja);
    } else if (this.$lang() == "4") {
      picker.use(vi);
    } else {
      picker.use(en);
    }
    //获取设备屏幕的高度
    const h = document.body.clientHeight - 50;
    this.$refs.middle_page.style.minHeight = h + "px";

    this.$autoLogin().then(
      () => {
        //接收参数
        this.courseId = this.$route.query.courseId;
        //登录成功
        this.userId = window.sessionStorage.getItem("id");
        this.role = window.sessionStorage.getItem("role");

        //获取学习进度信息
        this.$api
          .post("/home/getlearningProgress", {
            languageType: this.$lang(),
            pageQuery: {
              pageNum: this.pageNum,
              pageSize: this.pageSize,
            },
          })
          .then((response) => {
            if (response.data.list.length > 0) {
              this.resultFlag = true;
              this.totalPage = response.data.total;
              this.searchResultList = response.data.list;
              this.tableInfo = this.searchResultList;
            } else {
              this.totalPage = 0;
              this.tableInfo = [];
              this.resultFlag = false;
            }
            document.getElementById("app").scrollTo(0, 0);
          });
      },
      () => {
        //未登录跳回首页
        this.$router.push({
          path: "/home",
        });
        this.$message.warning(window.vm.$i18n.t("read.login"));
      }
    );
  },
  methods: {
    //点击搜索按钮
    search() {
      this.$api
        .post("/home/getCourseByCourseNameKeyword", {
          startOfValidity: this.startOfValidity,
          endOfValidity: this.endOfValidity,
          keyword: this.keyword,
          languageType: this.$lang(),
          pageQuery: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          if (response.data.list.length > 0) {
            this.resultFlag = true;
            this.totalPage = response.data.total;
            this.searchResultList = response.data.list;
            this.tableInfo = this.searchResultList;
          } else {
            this.totalPage = 0;
            this.tableInfo = [];
            this.resultFlag = false;
          }
          document.getElementById("app").scrollTo(0, 0);
        });
    },

    handleCurrentChange(val) {
      // 改变默认的页数
      //this.currentPage=val
      this.page = val;
      this.pageNum = val;
      this.search();
    },

    startCalendarClick(val) {},

    endCalendarClick(val) {},
    float: function (comp, uncomp) {
      let num = (comp / (comp + uncomp)) * 100;
      return num.toFixed(1);
    },
  },
};
</script>

<style scoped="scoped">

  .page-bk-col{
    background-color: #ffffff;
  }
  .form-item{
    /*margin-left: 50px;*/
  }
  .font_col {
    color: #ffffff;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }
  .exam_page {
    width: 100%;
    height: 100%;
    /* background-image: url("https://static.wixstatic.com/media/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.jpg/v1/fill/w_1920,h_1920,al_c,q_85,usm_0.66_1.00_0.01/a36401_d0e7d0a145014c1e97b8c245bbea3988~mv2_d_3900_3900_s_4_2.webp"); */
    /* background: url(/static/images/bg/personset_bg2.jpg); */
    background: url(/static/images/bg/personset_bg.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    position: relative;
  }

  .exam_main {
    background-color: rgba(65, 65, 65,0.5);
    width: 100%;
    height: 100%;
    min-height: 100%;
    padding-bottom: 50px;
  }

  .examPage {
    /*min-width: 1800px;*/
    width: 96%;
    height: 100%;
    margin: 0 auto;
    padding-top: 20px;
  }

  .examCenter_img {
    margin-top: 40px;
    width: 40%;
    margin-left: calc(20% - 30px);
    position: relative;
  }

  .examCenter_img img {
    height: 120px;
  }

  .examCenter_img p:first-child {
    font-size: 40px;
    color: #FAFAFA;
    font-family: marzo-w00-regular, fantasy;
    font-weight: 400;
  }

  .examCenter_img p:first-child span {
    font-size: 40px;
    color: #FF5252;
    font-family: braggadocio-w01, fantasy;
    font-weight: 400;
  }

  .examCenter_img p:nth-child(2) {
    font-size: 45px;
    color: #E8E6E6;
    font-family: roboto-thin, roboto, sans-serif;
    font-weight: 400;
  }


  .exam_begins_box {
    min-width: 900px;
    width: 80%;
    height: 100%;
    padding: 30px;
    border-radius: 15px;
    padding-bottom: 60px;
    /*margin-left: 120px;*/
    margin:0 auto;
    margin-top: 80px;
    background-color: rgba(0, 0, 0, 0.3);
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
    position: relative;
  }
  .course_box {
    /*min-width: 1250px;*/
    height: 100%;
    width: 100%;
 /*   padding: 30px;*/
    border-radius: 15px;
  : 10px auto;
    background-color: rgba(0, 0, 0, 0.3);
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
    position: relative;
  }

  .exam_page_span {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, .3);
  }

  .examination_notes {
    height: 20px;
    font-size: 20px;
    color: #E8E6E6;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_begins_box .exam_begins_rule {
    position: relative;
    display: -webkit-flex;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px #414141 solid;
  }

  .exam_begins_rule .exam_begins_rule_title {
    width: auto;
    height: 20px;
    margin-right:10px;
    font-size: 14px;
    color: #E8E6E6;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_begins_rule .exam_begins_rule_content {
    width: 520px;
    min-height: 20px;
    position: relative;
    display: block;
  }

  .exam_begins_rule .exam_begins_rule_content p {
    min-height: 20px;
    line-height: 20px;
    display: flex;
    font-size: 14px;
    color: #E8E6E6;
    text-align: left;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_notes {
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #E8E6E6;
    text-align: center;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
  }

  .exam_notes:first-child {
    margin-top: 40px;
  }

  .exam_btn {
    margin: 0 auto;
    margin-top: 3px;
    display: block;
    text-align: center;
    font-size: 16px;
    color: #E8E6E6;
    background-color: unset;
    padding: 5px 20px 6px 17px;
    border: 1px solid #E8E6E6;
    border-radius: 20px;
    font-family: source-han-sans-simplified-c, sans-serif;
    font-weight: 200;
    font-style: normal;
    transition:0.5s ease;
  }

  .exam_btn:hover {
    color: #000;
    background-color: #fff;
    transition:0.5s ease;
  }
  .item {
    margin-top: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }

  @media screen and (max-width: 1024px){
    .examPage{
      width: calc(100% - 60px);
    }
    .exam_begins_box{
      width: 94%;
      min-width: 500px;
      padding: 3%;
    }
    .form-item{
      margin-left: 0px;
    }
    .el-col-7,
    .el-col-6{
      text-align: left;
      min-width:100px;
      width:unset;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/learnanalysis/courseProgress.vue